module.exports = __webpack_public_path__ + "img/132w.adf59a5.jpg";